import isEqual from 'lodash/isEqual'

export default function ({ route, store, from }) {
  if (!from || isEqual(from, route)) {
    return true
  }

  store.commit('app/setRouteFrom', from)
}
